import Vue from 'vue'
import '@/plugins/axios'
import '@/plugins/veeValidate'
import Member from './MemberMain.vue'
import '@/registerServiceWorker'
import axios from 'axios'
import router from '@/router/member'
import store from '@/store/member'
import vuetify from '@/plugins/vuetify/member/vuetify'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
axios.defaults.baseURL = `${window.location.origin}`

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(Member),
}).$mount('#app')
